import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import ReduxToastr from "react-redux-toastr";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { ThemeProvider } from "styled-components";
// @ts-ignore
import { pdfjs } from "react-pdf";

import { unregister } from "./serviceWorker";
import { theme } from "./theme";

import configureStore from "./store";
import initAmplitude from "./api/amplitude";
import getDropbox, { initDropbox } from "./api/dropbox";
import initFirebase from "./api/firebase";
import initGoogleDrive from "./api/googleDrive";
import createSpeech from "./api/speech";
// components
import { GlobalStyle } from "./app/components/styled/GlobalStyle";
import { LogoSpinner } from "./app/components/LogoSpinner";

import { getUserConfirmation } from "./utils/getUserConfirmation";
import { DropboxProvider } from "./app/providers/Dropbox";
import { DROPBOX_PATH } from "./app/constants/dropbox";

initFirebase();
initDropbox();
initGoogleDrive();

export const amplitude = initAmplitude();
export const store = configureStore();
export const speech = createSpeech(store);
const dropbox = getDropbox();

const DropboxCode = React.lazy(() => import("./app/pages/DropboxCode"));
const Home = React.lazy(() => import("./app/pages/Home"));

const CreateApp: React.FC = () => (
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <BrowserRouter getUserConfirmation={getUserConfirmation}>
        <DropboxProvider dropbox={dropbox}>
          <Suspense fallback={<LogoSpinner />}>
            <Switch>
              <Route path={`/${DROPBOX_PATH}`} component={DropboxCode} exact />

              <Route path={["/", "/settings", "/record", "/folder"]} component={Home} />

              <Redirect to="/" />
            </Switch>
          </Suspense>

          <GlobalStyle />

          <ReduxToastr
            timeOut={4000}
            newestOnTop={false}
            preventDuplicates
            position="top-right"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
            progressBar
            closeOnToastrClick
          />
        </DropboxProvider>
      </BrowserRouter>
    </ThemeProvider>
  </Provider>
);

ReactDOM.render(
  <CreateApp />,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregister();

// https://www.npmjs.com/package/react-pdf#standard-browserify-and-others
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
